import 'lazysizes';
import Gallery from './src/modules/gallery';
import GoogleMap from './src/modules/google-map.js';
import Header from './src/modules/header.js';
import Instagram from './src/modules/instagram.js';

document.addEventListener('DOMContentLoaded', onLoad);

function onLoad() {
	new Header();

	const instagramElements = document.querySelectorAll('.instagram-element');
	instagramElements.forEach(element => new Instagram(element));

	const galleries = document.querySelectorAll('.luminous-gallery');
	galleries.forEach(gallery => new Gallery(gallery));

	const googleMaps = document.querySelectorAll('.google-map');
	googleMaps.forEach(map => new GoogleMap(map));

	const footer = document.querySelector('footer.footer');
	if (footer) {
		const footerObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					loadScript('https://contact-api.inguest.com/bundles/revinatecontactapi/js/revinate-form.js?v=1');
					footerObserver.unobserve(footer);
				}
			})
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.01,
		});
		footerObserver.observe(footer);




		const revinateForm = document.getElementById('revinate_contact_api_form');
		const revinateSubmitButton = revinateForm?.querySelector('button[type="submit"]');

		const formObserver = new MutationObserver((mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type !== 'attributes') {
					continue;
				}
				if (mutation.attributeName !== 'disabled') {
					continue;
				}
				const isDisabled = revinateSubmitButton.hasAttribute('disabled');
				if (!isDisabled) {
					return;
				}
				const p = document.createElement('p');
				p.textContent = '🎉 Thanks for signing up!';
				revinateForm.after(p);
				revinateForm.remove();
				formObserver.disconnect();
			}
		});

		if (revinateForm && revinateSubmitButton) {
			formObserver.observe(revinateSubmitButton, { attributes: true });
		}
	}

}


function loadScript(url) {
	const script = document.createElement('script');
	script.src = url;
	document.body.appendChild(script);
}

